module.exports = __webpack_public_path__ + "img/生产.70224fc3.svg";